import { Pricing as Control } from "./Pricing";
import type { PricingProps } from "./types";

export const Pricing = (props: PricingProps) => {
  return <Control {...props} />;
};

export * from "./types";
